import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkButton } from './uitk-button.esm.js';

var UitkPrimaryButton = /** @class */ (function (_super) {
    __extends(UitkPrimaryButton, _super);
    function UitkPrimaryButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkPrimaryButton.prototype.render = function () {
        var _a;
        var _b = this.props, inverse = _b.inverse, props = __rest(_b, ["inverse"]);
        var cssClassNames = classNames("".concat(UitkButton.baseClassName, "-primary"), (_a = {},
            _a["".concat(UitkButton.baseClassName, "-primary-inverse")] = inverse,
            _a), props.className);
        return React.createElement(UitkButton, __assign({}, props, { className: cssClassNames }));
    };
    UitkPrimaryButton.displayName = 'UitkPrimaryButton';
    return UitkPrimaryButton;
}(React.Component));

export { UitkPrimaryButton };
